import { useState } from 'react';

const useForgottenPassword = ({ handleForgottenPassword, handleForgottenPasswordSubmit }) => {
  const defaultFormValues = {
    resetCode: '', password: '', confirmPassword: '', emailAddress: '',
  };
  const [formData, setFormData] = useState(defaultFormValues);
  const [formStep, setFormStep] = useState(0);
  const [error, setError] = useState(null);

  const nextFormStep = () => setFormStep(() => formStep + 1);

  const onSubmitForgotPasswordRequest = async (event) => {
    try {
      await handleForgottenPassword(event?.emailAddress?.toLowerCase());
      setFormData({ ...formData, ...event });
      nextFormStep();
    } catch (err) {
      setError('Something went wrong. Please try again or contact an administrator.');
    }
  };

  const onSubmitForgotPassword = async (event) => {
    try {
      const { emailAddress, resetCode, password } = event;

      await handleForgottenPasswordSubmit(emailAddress, resetCode.trim(), password);
      nextFormStep();
    } catch (err) {
      setError('Failed to update password. Please try again or contact an administrator.');
    }
  };

  return {
    formData,
    formStep,
    onSubmitForgotPasswordRequest,
    onSubmitForgotPassword,
    error,
  };
};

export default useForgottenPassword;
